<template>
  <div class="mt-5">
    <vs-tabs position="left">
      <vs-tab label="Company Information" icon-pack="feather" icon="icon-user">
        <CompanyInformation />
      </vs-tab>
      <vs-tab label="Company Schedule" icon-pack="feather" icon="icon-calendar">
        <CompanySchedule />
      </vs-tab>
      <vs-tab label="Company Settings" icon-pack="feather" icon="icon-settings">
        <CompanySettings />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import CompanyInformation from "./company-view/CompanyInformation.vue";
import CompanySchedule from "./company-view/CompanySchedule.vue";
import CompanySettings from "./company-view/CompanySettings.vue";

export default {
  components: {
    CompanyInformation,
    CompanySchedule,
    CompanySettings,
  },
};
</script>
